module.exports = __webpack_public_path__ + "static/media/filip-baotic-HjZ0qARrQDY-unsplash.c1f80f85.jpg";